import {getRouteWithVariablesReplaced} from '@netx/core-next/utils/route';
import {SystemPeopleViewTab} from './constants';

export {SystemPeopleViewTab} from './constants';

const baseRoute = `people`;

export enum SystemPeopleRoute {
	BASE = `${baseRoute}(/:tab)`,
}

export const SYSTEM_PEOPLE_ROUTE_REGEX = {
	BASE:
		// eslint-disable-next-line security/detect-unsafe-regex
		// /^\/system\/attribute\/people(\/[^\s\/]+)?$/,
		new RegExp(`^(\/)?${baseRoute.replace(/\//g, '\\/')}(\/[^\s\/]+)?$`),
} as const;

export const SystemPeopleRouteUtil = {
	BASE: <Tab extends SystemPeopleViewTab | undefined>(tab?: Tab) => {
		const route = getRouteWithVariablesReplaced<
			SystemPeopleRoute.BASE,
			Tab extends undefined ? typeof baseRoute : `${typeof baseRoute}/${Tab}`
		>(SystemPeopleRoute.BASE, tab);
		if (!route || !route.match(SYSTEM_PEOPLE_ROUTE_REGEX.BASE))
			throw new Error(`Invalid route: ${route}`);

		return route;
	},
};
